import * as SliderPrimitive from '@radix-ui/react-slider'
import type * as React from 'react'

import { cn } from '~/shared/lib/utils'

interface SliderProps extends React.ComponentProps<typeof SliderPrimitive.Root> {
  /** Read out for the thumb; not shown. */
  thumbLabel: string
  /** Read out instead of the bare number, e.g. with its unit. */
  thumbValueText?: string
  size?: 'default' | 'lg'
}

function Slider({
  className,
  thumbLabel,
  thumbValueText,
  size = 'default',
  ...props
}: SliderProps) {
  const large = size === 'lg'
  return (
    <SliderPrimitive.Root
      data-slot="slider"
      className={cn(
        'relative flex w-full touch-none select-none items-center data-[disabled]:opacity-50',
        large ? 'py-3' : 'py-2',
        className,
      )}
      {...props}
    >
      <SliderPrimitive.Track
        data-slot="slider-track"
        className={cn(
          'relative w-full grow overflow-hidden rounded-full bg-muted',
          large ? 'h-2.5' : 'h-1.5',
        )}
      >
        <SliderPrimitive.Range
          data-slot="slider-range"
          className={cn(
            'absolute h-full',
            large ? 'bg-gradient-to-r from-brand to-brand-strong' : 'bg-brand',
          )}
        />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        data-slot="slider-thumb"
        aria-label={thumbLabel}
        aria-valuetext={thumbValueText}
        className={cn(
          'block shrink-0 rounded-full outline-none transition-[box-shadow,transform] motion-reduce:transition-none',
          large
            ? 'size-6 cursor-grab border-4 border-background bg-brand shadow-md ring-1 ring-brand/30 hover:ring-[6px] hover:ring-brand/15 focus-visible:ring-[6px] focus-visible:ring-brand/30 active:scale-110 active:cursor-grabbing'
            : 'size-4 border border-brand bg-background shadow-sm hover:ring-4 hover:ring-brand/20 focus-visible:ring-4 focus-visible:ring-brand/40',
        )}
      />
    </SliderPrimitive.Root>
  )
}

export { Slider }
